import { axiosInstance } from "./axiosInstance";

export async function updateTax(
  vendorId: number,
  tax: { baseTax: number, taxPercent: number },
  listingId?: number)
{
  return axiosInstance.post("/vendors/updateTax", { vendorId, tax, listingId })
    .catch(error => console.log("Error updating vendor tax", error));
}
